"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/******************************************** IMPORTS *********************************************/
var date_time_all_1 = require("./date-time-all");
var moment_1 = __importDefault(require("moment"));
var defDateFormat = "YYYY-MM-DD";
/********************************************* EXPORT *********************************************/
/**
 * Using ambiguous date-like input, construct a jvln LocalDate object
 * @param {string|null|undefined|LocalDate|Moment} date Value to convert to a LocalDate (or null)
 * @param {string} dateFormat String (OPTIONAL)
 * @param {string} notScheduledText Text marking a 'not scheduled'
 */
exports.extractLocalDate = function (date, dateFormat, notScheduledText) {
    // If it's null or undefined, return null
    if (typeof date === 'undefined' || (date === null && date !== ''))
        return null;
    if (typeof date === 'string') {
        var matchNotScheduledText = typeof notScheduledText !== 'undefined' &&
            notScheduledText !== null &&
            (typeof notScheduledText === 'string'
                ? notScheduledText && date.toLowerCase() === notScheduledText.toLowerCase()
                : !!notScheduledText.find(function (txt) { return txt.toLowerCase() === date.toLowerCase(); }));
        // Tries to determine if it's a 'not scheduled' indicator w/out needing language in advance
        // TODO [extractLocalDate] This is a bit much. Find better way to handle 'not scheduled' string
        if (matchNotScheduledText ||
            date.toLowerCase() === 'not received' ||
            date.toLowerCase() === 'not scheduled' ||
            date.toLowerCase() === 'non reçu' ||
            date.toLowerCase() === 'non prévu')
            return null;
    }
    // If it's already LocalDate or ZonedDateTime, clone it and return it
    if (date instanceof date_time_all_1.LocalDate || date instanceof date_time_all_1.ZonedDateTime) {
        return new date_time_all_1.LocalDate(date);
    }
    // If it's a moment object, use it to build a LocalDate, then return it
    if (moment_1.default.isMoment(date))
        return new date_time_all_1.LocalDate(date);
    //
    // If it's a string: 1) Extract valid pieces (year, month, date), 2) Build moment
    // object from them; & 3) Use moment object to construct & return a LocalDate
    //
    if (typeof date === 'string') {
        var dateParts = date.match(/\w+/g);
        if (!dateParts || dateParts.length < 3)
            return null;
        var rawMonthString = dateParts[0], dateOfMonth = dateParts[1], year = dateParts[2];
        // e.g. => ['December', '21', '2017']
        var monthAbbrev_1 = rawMonthString.substring(0, 3);
        var monthIdx = moment_1.default.monthsShort().findIndex(function (mon) { return mon === monthAbbrev_1; }); // <- 0-11
        var month = monthIdx !== -1 ? monthIdx + 1 : null;
        // If no match found for month, this was a bad date string, so return null
        if (month === null)
            return null;
        return new date_time_all_1.LocalDate(moment_1.default(year + "-" + month + "-" + dateOfMonth, dateFormat || defDateFormat));
    }
};
//# sourceMappingURL=date-helpers.js.map